import { render, staticRenderFns } from "./OverlayBottom.vue?vue&type=template&id=65647d85"
import script from "./OverlayBottom.vue?vue&type=script&lang=ts"
export * from "./OverlayBottom.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports